<template>
  <div class="wrapper-dashboard" :class="currentLocale">
    <!-- Support PC Tablet -->
    <div v-if="isTablat" class="h-100">
      <div
        class="image__hearder"
        crm_at="image_hearder"
        :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
        @scroll="onScroll"
      >
        <div class="box_content">
          <div class="wrapper__home__page">
            <div class="wrapper_hearder">
              <LayoutHome
                :reset="resetProfile"
                @changeLayoutHome="ChangeLayoutHome($event)"
                @changeGetPoints="ChangeGetPoints($event)"
                @changeGetStamp="ChangeGetStamp($event)"
                @changePointsExpired="ChangePointsExpired($event)"
              />
            </div>
            <div class="wrapper_content">
              <div class="row">
                <div class="col-12 mt-4 mb-4">
                  <span class="text-welcome" crm_at="text_detail">
                    <p
                      v-if="isStore == 'point' && isShowPoint"
                      class="page-point-detail"
                      crm_at="text_point_detail"
                    >
                      {{ this.textDetail }}
                    </p>
                    <p
                      v-if="isStore == 'stamp' && isShowPoint"
                      class="page-point-detail"
                      crm_at="text_stamp_detail"
                    >
                      {{ this.textDetailStamp }}
                    </p>
                  </span>
                </div>
              </div>
              <div>
                <a-list :data-source="dataList" crm_at="list">
                  <a-list-item
                    slot="renderItem"
                    slot-scope="item"
                    class="wrapper-list"
                    :class="[
                      { 'wrapper-list-package': isTypePackage(item.Extra) },
                    ]"
                    crm_at="wrapper_list"
                  >
                    <div
                      v-if="isTypePackage(item.Extra)"
                      class="wrapper-box"
                    ></div>
                    <div v-if="isTypePackage(item.Extra)" class="frame1"></div>
                    <div v-if="isTypePackage(item.Extra)" class="frame2"></div>
                    <a-list-item-meta
                      crm_at="list_campaign"
                      @click="handleDetail(item.ID)"
                    >
                      <div slot="title" class="detail-item">
                        <a class="list-name">
                          <a-tooltip
                            placement="topLeft"
                            :title="item.Name"
                            arrow-point-at-center
                          >
                            <div class="name-section">
                              <div
                                v-if="
                                  isTypePackage(item.Extra) &&
                                  displayQTY(item.Extra)
                                "
                                class="qty"
                              >
                                <span class="prefix">x</span>
                                <span class="number">
                                  {{ displayQTY(item.Extra) }}
                                </span>
                              </div>
                              <strong class="name">{{ item.Name }}</strong>
                            </div>
                          </a-tooltip>
                        </a>
                        <div class="use-points">
                          <div
                            v-if="
                              isTypePackage(item.Extra) &&
                              dateShortFormatUTC(item.ExpireDate)
                            "
                            class="expire"
                          >
                            {{
                              lbl.main.expired_on_text +
                              ': ' +
                              dateShortFormatUTC(item.ExpireDate, true)
                            }}
                          </div>
                          <a-button
                            v-if="isStore == 'point'"
                            type="primary"
                            shape="round"
                            :crm_at="'btn_use_points_' + item.ID"
                            class="btn-crm-l btn-use-points"
                            :style="{
                              'background-color': backgroundPointColor
                                ? backgroundPointColor
                                : '#1890ff',
                              'border-color': backgroundPointColor
                                ? backgroundPointColor
                                : '#1890ff',
                              color: textPointColor
                                ? textPointColor
                                : '#FFFFFF',
                            }"
                            :value="item.ID"
                            @click="handleUsePoints"
                          >
                            <span
                              v-if="
                                item.PointPerUnit <= 0 &&
                                item.Type != 8 &&
                                item.Type != 16
                              "
                            >
                              {{ lbl.main.free }}
                            </span>
                            <span v-else-if="item.PointType == 'use'">
                              {{ lbl.main.use }} {{ item.PointPerUnit }}
                              {{ lbl.main.points }}
                            </span>
                            <span v-else-if="item.Type == 8">
                              {{ lbl.default.join }}
                            </span>
                            <span v-else-if="item.Type == 16">
                              {{ lbl.lucky_draw.button_seemore }}
                            </span>
                            <span v-else>
                              {{ lbl.main.use }} {{ item.PointPerUnit }}
                              {{ lbl.main.points }}
                            </span>
                          </a-button>
                        </div>
                      </div>
                      <a-avatar
                        slot="avatar"
                        shape="square"
                        :size="100"
                        :src="item.FullImageUrl"
                        @click="handleDetail(item.ID)"
                      />
                    </a-list-item-meta>
                  </a-list-item>
                  <div
                    v-if="loading && !busy"
                    class="demo-loading-container text-center"
                  >
                    <a-spin />
                  </div>
                </a-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Support Mobile -->
    <div v-else v-scroll-loadmorebody="loadmore">
      <LayoutHome @changeLayoutHome="ChangeLayoutHome($event)" />
      <div class="row">
        <div
          v-if="isStore == 'stamp' && isShowEarnCode"
          class="col-12 text-center m-rectangle"
        >
          <div
            class="row box-stamp"
            :style="{
              'background-color': backgroundStamp ? backgroundStamp : '#FFF',
              'border-color': backgroundStamp ? backgroundStamp : '#eee',
            }"
          >
            <div
              v-for="item in StampProfile"
              :key="item.no"
              class="stamp-circle"
              crm_at="stamp_circle"
            >
              <div
                class="stamp-index"
                crm_at="stamp_index"
                :class="[
                  {
                    active_stamp: item.is_active,
                    isGrayscale: item.isGrayscale,
                  },
                ]"
                :style="[{ 'background-image': 'url(' + item.imgStamp + ')' }]"
                @click="onClickStamp(item.id)"
              >
                {{ item.no }}
              </div>
            </div>
            <div v-if="isPagination" class="box-pagination w-100">
              <div class="show-page">
                <a-pagination
                  :total="totalStamp"
                  :default-current="1"
                  :item-render="itemRender"
                  crm_at="change_page_stamp"
                  @change="onChangePage"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center m-rectangle">
          <a-button
            v-if="isStore == 'point' && isShowEarnCode"
            type="primary"
            shape="round"
            crm_at="btn_get_points"
            class="btn-crm-xl"
            :style="{
              'background-color': backgroundColor ? backgroundColor : '#1890ff',
              'border-color': backgroundColor ? backgroundColor : '#1890ff',
              color: textColor ? textColor : '#FFFFFF',
            }"
            @click="handleGetPoints"
          >
            <span
              class="label-rectangle"
              :style="{ color: textColor ? textColor : '#FFFFFF' }"
              >{{ lbl.dashboard.click_points }}</span
            >
          </a-button>
          <a-button
            v-if="isStore == 'stamp' && isShowEarnCode"
            type="primary"
            shape="round"
            crm_at="btn_get_stamp"
            class="btn-crm-xl"
            :style="{
              'background-color': backgroundColor ? backgroundColor : '#1890ff',
              'border-color': backgroundColor ? backgroundColor : '#1890ff',
              color: textColor ? textColor : '#FFFFFF',
            }"
            @click="handleGetStamp"
          >
            <span
              class="label-rectangle"
              :style="{ color: textColor ? textColor : '#FFFFFF' }"
              >{{ lbl.stamp.click_stamp }}</span
            >
          </a-button>
          <a-button
            v-if="ShowValueDesignOnConsumer && cardData.length"
            type="primary"
            shape="round"
            crm_at="btn_my_card"
            class="btn-my-card"
            :style="{
              'background-color': '#ffffff',
              'border-color': backgroundColor ? backgroundColor : '#1890ff',
              color: textColor ? textColor : '#FFFFFF',
            }"
            @click="goto('myCard')"
          >
            <a-icon
              type="credit-card"
              :style="{
                color: backgroundColor ? backgroundColor : '#FFFFFF',
              }"
            />
            <span
              class="label-rectangle"
              :style="{ color: backgroundColor ? backgroundColor : '#FFFFFF' }"
            >
              {{ lbl.value_design.home.my_card_btn }}
            </span>
          </a-button>
        </div>
        <div class="col-12 pt-3">
          <div class="text-center">
            <span class="text-welcome" crm_at="text_welcome">
              {{ this.textWelcome }}
            </span>
          </div>
          <div class="text-center mt-2">
            <label
              v-if="isStore == 'point' && isShowPoint"
              class="page-point"
              crm_at="text_point"
            >
              <span
                v-if="
                  isDisplayUserLevel && userLevel && currentLevel != undefined
                "
              >
                <img
                  v-if="
                    userLevel &&
                    profileLevel.currentLevelIcon != null &&
                    profileLevel.currentLevelIcon != ''
                  "
                  class="profile__image"
                  :src="profileLevel.currentLevelIcon"
                  alt="userlevel"
                />
              </span>

              {{ lbl.dashboard.you_have }}
              <span class="lbl-point">{{ Point }}</span>
              {{ lbl.dashboard.you_points }}
              <img
                src="@/assets/images/info.svg"
                class="img-info"
                alt=""
                @click="handlePointsExpired"
              />
            </label>
            <p
              v-if="isStore == 'point' && isShowPoint"
              class="page-point-detail mt-2"
              crm_at="text_point_detail"
            >
              {{ PointsExpired }} {{ lbl.dashboard.points_expired }}
              {{ DateExpired }}
            </p>
            <p
              v-if="isStore == 'stamp' && isShowPoint"
              class="page-point-detail"
              crm_at="text_stamp_detail"
            >
              {{ this.textDetailStamp }}
            </p>
          </div>
          <div class="px-3 pt-4">
            <a-list :data-source="dataList" crm_at="list">
              <a-list-item
                slot="renderItem"
                slot-scope="item"
                class="wrapper-list"
                :class="[{ 'wrapper-list-package': isTypePackage(item.Extra) }]"
                crm_at="wrapper_list"
              >
                <div v-if="isTypePackage(item.Extra)" class="wrapper-box"></div>
                <div v-if="isTypePackage(item.Extra)" class="frame1"></div>
                <div v-if="isTypePackage(item.Extra)" class="frame2"></div>
                <a-list-item-meta
                  :crm_at="'list_campaign_' + item.ID"
                  @click="handleDetail(item.ID)"
                >
                  <div
                    slot="title"
                    :crm_at="'list_detail_' + item.ID"
                    class="detail-item"
                  >
                    <a class="list-name" :crm_at="'list_name_' + item.ID">
                      <a-tooltip
                        placement="topLeft"
                        :title="item.Name"
                        arrow-point-at-center
                      >
                        <div class="name-section">
                          <div
                            v-if="
                              isTypePackage(item.Extra) &&
                              displayQTY(item.Extra)
                            "
                            class="qty"
                          >
                            <span class="prefix">x</span>
                            <span class="number">
                              {{ displayQTY(item.Extra) }}
                            </span>
                          </div>
                          <strong class="name">{{ item.Name }}</strong>
                        </div>
                        <div v-if="isStore == 'stamp'" class="detail">
                          {{ item.Detail }}
                        </div>
                      </a-tooltip>
                    </a>
                    <div
                      class="use-points"
                      :crm_at="'list_use_points_' + item.ID"
                    >
                      <div
                        v-if="
                          isTypePackage(item.Extra) &&
                          dateShortFormatUTC(item.ExpireDate)
                        "
                        class="expire"
                      >
                        {{
                          lbl.main.expired_on_text +
                          ': ' +
                          dateShortFormatUTC(item.ExpireDate, true)
                        }}
                      </div>
                      <a-button
                        v-if="isStore == 'point'"
                        type="primary"
                        shape="round"
                        :crm_at="'btn_use_points_' + item.ID"
                        class="btn-crm-l btn-use-points"
                        :style="{
                          'background-color': backgroundPointColor
                            ? backgroundPointColor
                            : '#1890ff',
                          'border-color': backgroundPointColor
                            ? backgroundPointColor
                            : '#1890ff',
                          color: textPointColor ? textPointColor : '#FFFFFF',
                        }"
                        :value="item.ID"
                        @click="handleUsePoints"
                      >
                        <span
                          v-if="
                            item.PointPerUnit <= 0 &&
                            item.Type != 8 &&
                            item.Type != 16
                          "
                        >
                          {{ lbl.main.free }}
                        </span>
                        <span v-else-if="item.PointType == 'use'">
                          {{ lbl.main.use }} {{ item.PointPerUnit }}
                          {{ lbl.main.points }}
                        </span>
                        <span v-else-if="item.Type == 8">
                          {{ lbl.default.join }}
                        </span>
                        <span v-else-if="item.Type == 16">
                          {{ lbl.lucky_draw.button_seemore }}
                        </span>
                        <span v-else>
                          {{ lbl.main.use }} {{ item.PointPerUnit }}
                          {{ lbl.main.points }}
                        </span>
                      </a-button>
                    </div>
                  </div>
                  <a-avatar
                    slot="avatar"
                    :crm_at="'list_avatar_' + item.ID"
                    shape="square"
                    :size="100"
                    :src="item.FullImageUrl"
                    @click="handleDetail(item.ID)"
                  />
                </a-list-item-meta>
              </a-list-item>
              <div
                v-if="loading && !busy"
                class="demo-loading-container text-center"
              >
                <a-spin />
              </div>
            </a-list>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      v-model="showModalBarcode"
      :footer="null"
      class="modal-Barcode"
      crm_at="modal_barcode"
      centered
      :after-close="BarcodeClose"
    >
      <div class="row" :class="currentLocale">
        <div class="col-12 modal-img">
          <button
            type="button"
            class="close-btn"
            crm_at="clos_barcode"
            data-dismiss="modal"
            @click="closeModalBarcode"
          >
            <img
              src="@/assets/images/close-icon.svg"
              class="close-icon"
              alt=""
            />
          </button>
          <div
            v-if="
              windowWidth >= 600 &&
              windowHeight >= 600 &&
              isStore == 'stamp' &&
              isShowEarnCode
            "
          >
            <div class="text-center div-stamp">
              <label class="my-stamp" crm_at="my-stamp">
                {{ lbl.main.my_stamp }}
              </label>
            </div>
          </div>
          <a v-else href="#">
            <img
              class="modal-img-logo"
              crm_at="modal_img_logo"
              :src="imageLogo"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="row" :class="currentLocale">
        <div
          v-if="windowWidth >= 600 && windowHeight >= 600"
          class="col-12 text-center mt-3"
        >
          <div v-if="isStore == 'point'" class="text-title" crm_at="title">
            {{ lbl.default.welcome }}<br />
            {{ storeinfo.businessName }}
          </div>

          <hr v-if="isStore == 'stamp' && isShowEarnCode" />
          <div
            v-if="isStore == 'stamp' && isShowEarnCode"
            class="col-12 text-center"
          >
            <div
              class="row box-stamp"
              :style="{
                'background-color': backgroundStamp ? backgroundStamp : '#FFF',
                'border-color': backgroundStamp ? backgroundStamp : '#eee',
              }"
            >
              <div
                v-for="item in StampProfile"
                :key="item.no"
                class="stamp-circle"
                crm_at="stamp_circle"
              >
                <div
                  class="stamp-index"
                  crm_at="stamp_index"
                  :class="[
                    {
                      active_stamp: item.is_active,
                      isGrayscale: item.isGrayscale,
                    },
                  ]"
                  :style="[
                    { 'background-image': 'url(' + item.imgStamp + ')' },
                  ]"
                  @click="onClickStamp(item.id)"
                >
                  {{ item.no }}
                </div>
              </div>
              <div v-if="isPagination" class="box-pagination w-100">
                <div class="show-page">
                  <a-pagination
                    :total="totalStamp"
                    :default-current="1"
                    :item-render="itemRender"
                    crm_at="change_page_stamp"
                    @change="onChangePage"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div class="col-12 text-center pt-3">
          <p class="page-point-detail" crm_at="page_point_detail">
            {{ lbl.main.show_code_merchant_staff }}
          </p>
          <p
            v-if="
              windowWidth >= 600 &&
              windowHeight >= 600 &&
              isStore == 'stamp' &&
              isShowPoint
            "
            class="stamp-detail"
            crm_at="text_stamp_detail"
          >
            {{ this.textDetailStamp }}
          </p>
        </div>
        <div class="col-12 text-center pt-4">
          <a-tabs
            :default-active-key="ActiveKey ? ActiveKey : '1'"
            :active-key="ActiveKey ? ActiveKey : '1'"
            crm_at="tabs"
            @change="changeActiveKey"
          >
            <a-tab-pane key="1" crm_at="tab_qrcode">
              <span slot="tab" crm_at="btn_qrcode">
                {{ lbl.btn.qrcode }}
              </span>
              <div class="mt-qrcode">
                <vue-qrcode
                  :value="this.Barcode.code"
                  crm_at="qrcode"
                  :options="{ width: 210 }"
                ></vue-qrcode>
                <div class="taxt-qrcode" crm_at="taxt_qrcode">
                  {{ this.Barcode.code }}
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" crm_at="tab_barcode">
              <span slot="tab" crm_at="btn_barcode">
                {{ lbl.btn.barcode }}
              </span>
              <div class="mt-barcode">
                <vue-barcode
                  :value="this.Barcode.code"
                  crm_at="barcode"
                  :options="{ displayValue: true, width: 2.8, height: 120 }"
                  :class="{ 'barcode-container': isLong }"
                ></vue-barcode>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" crm_at="tab_code">
              <span slot="tab" crm_at="btn_code">
                {{ lbl.btn.code }}
              </span>
              <div
                class="code d-flex justify-content-center"
                crm_at="taxt_code"
              >
                {{ this.Barcode.code }}
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="col-12 text-center pt-4">
          <p v-if="!isTime" class="page-point-detail" crm_at="time_left">
            <img src="@/assets/images/restore.svg" alt="" />
            {{ lbl.main.expired }}
            <span class="color-time">
              {{ this.timeLeft }}
            </span>
          </p>
          <p v-else class="page-point-detail" crm_at="expired_second">
            {{ lbl.main.expired_second }}
          </p>
        </div>
        <div class="col-12 text-center pt-4">
          <img
            class="img-logo-footer"
            crm_at="img_logo_footer"
            src="@/assets/images/bzbs-logo-new.png"
            alt=""
          />
        </div>
      </div>
    </a-modal>

    <AlertError
      :show="showError && openError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />

    <PointsExpired
      :show="showPointsExpired"
      :data="dataPointsExpired"
      @changeExpired="ChangeExpired($event)"
    />
    <ConsentMarketingModal
      v-if="isShowConsentMarketing"
      :button-color="backgroundColor"
      :button-text-color="textColor"
      @allowConsentMarketing="allowConsentMarketing"
      @closeConsentMarketing="closeConsentMarketing"
    />
    <SettingMarketing
      v-if="isSettingMarketing"
      :login-type="loginType"
      :modalcondition="modalcondition"
      :callback="consentSettingMarketing"
      @ChangeErrorMarketing="ChangeErrorSettingMarketing($event)"
    />
    <PackageExpireModal
      :show="isPackageExpire"
      :business-name="storeinfo.businessName"
    />
    <StoreTerminateModal
      :show="isStoreTerminate"
      :business-name="storeinfo.businessName"
    />
    <CookieAccept />
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import LayoutHome from '@/module/components/Home/LayoutHome'
import ConsentMarketingModal from '@/components/Modal/ConsentMarketingModal'
import SettingMarketing from '@/components/Modal/SettingMarketing.vue'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueBarcode from '@chenfengyuan/vue-barcode'
import BzbsStamp from '@/core/Home/BzbsStamp'
import AlertError from '@/components/Modal/AlertError'
import PointsExpired from '@/components/Modal/PointsExpired'
import Locale from '@/helper/Locale.js'
import BzbsProfile from '@/core/Account/service/BzbsProfile.js'
import BzbsAuth from '@/core/Account/service/BzbsAuth.js'
import BzbsPackage from '@/core/Account/service/BzbsPackage.js'
import Account from '@/helper/AccountHelper.js'
import Cache from '@/helper/Cache.js'
import Config from '@/helper/Config.js'
import moment from 'moment'
import CookieAccept from '@/components/Layout/CookieAccept'
import PackageExpireModal from '@/components/Modal/PackageExpireModal'
import StoreTerminateModal from '@/components/Modal/StoreTerminateModal'
import UAParser from 'ua-parser-js/dist/ua-parser.min.js'
import BzbsVD from '@/core/ValueDesign/BzbsValueDesign.js'

var intervalTimer
export default {
  name: 'Dashboard',
  components: {
    LayoutHome,
    VueQrcode,
    VueBarcode,
    AlertError,
    PointsExpired,
    CookieAccept,
    PackageExpireModal,
    ConsentMarketingModal,
    SettingMarketing,
    StoreTerminateModal,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      parser: new UAParser(),
      backgroundColor: '',
      textColor: '',
      dataList: [],
      loading: false,
      busy: false,
      showModalBarcode: false,
      imageLogo: '',
      textPoint: '',
      textDetail: '',
      textDetailStamp: '',
      Barcode: [],
      timeLeft: '00:00',
      dataLayoutHome: [],
      textWelcome: '',
      isStore: null,
      loginType: null,
      isSettingMarketing: false,
      modalcondition: {
        ismodalShow: true,
        isshowbtn: true,
        storeinfo: {
          buttoncolor: null,
          buttontextcolor: null,
        },
        notification: {
          email: false,
          sms: false,
          line: false,
        },
      },
      originalConsent: {},
      dataStamp: [],
      backgroundStamp: '',
      StampProfile: [],
      openError: false,
      showError: false,
      dataError: {},
      totalStamp: 0,
      currentStamp: 1,
      DataStampProfile: [],
      isPagination: false,
      isTime: false,
      loadMore: true,
      images: [],
      current_skip: 0,
      totalData: 0,
      backgroundPointColor: '',
      textPointColor: '',
      objProfileInfo: {},
      isShowEarnCode: true,
      isShowPoint: true,
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
      },
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      count: 5,
      resetProfile: false,
      ActiveKey: '1',
      showPointsExpired: false,
      dataPointsExpired: {},
      Point: 0,
      profile_url: '',
      PointsExpired: 0,
      DateExpired: '',
      locale: '',
      nomore: false,
      userLevel: '',
      haveUserLevel: false,
      currentLevel: {
        UserLevelIconUrl: null,
      },
      userLevelList: [],
      isTablat: false,
      isPackageExpire: false,
      isStoreTerminate: false,
      isShowConsentMarketing: false,
      currentLocale: Locale.getLocale(),
      profileLevel: {},
      levelmode: null,
      ShowValueDesignOnConsumer: false,
      cardData: [],
      ConsentNotification: 7,
      ConsentNotificationPeriod: 'day',
      isLong: false,
      isDisplayUserLevel: true,
      countGetCampaign: 0,
      version: {},
    }
  },
  watch: {
    Barcode(newVal) {
      if (newVal.code.length > 10) {
        this.isLong = true
      } else {
        this.isLong = false
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'package_expire_modal') {
        this.handleCheckRegister()
      }
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventShowFooter)
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    Account.bzbsAnalyticTracking(
      'home_page',
      'home_page',
      'view_home_page',
      'on view',
    )
    this.handleLoading(true)
    this.handleCheckLogin(this.$route)
    this.init()
    window.addEventListener('resize', this.myEventShowFooter)
    window.addEventListener('scroll', this.handleScroll)
    console.log(this.parser.getResult())
  },
  methods: {
    init() {
      this.handleLoading(true)
      this.checklocalStorage().then(() => {
        Promise.all([
          this.getCustomerStore().then(res => {
            this.ConsentNotification = res.ConsentNotification
            this.ConsentNotificationPeriod = res.ConsentNotificationPeriod
            if (this.ShowValueDesignOnConsumer) {
              Account.bzbsAnalyticTracking(
                'home_page',
                'home_page_with_value_design_page',
                'view_home_page_with_value_design_page',
                'on view',
              )
              this.getCardList()
            }
            if (res.StoreDetail.levelmode == 'spending') {
              this.getUserLevel().then(() => {
                this.getProfileLevelSpending()
              })
            } else {
              this.getUserLevel()
            }
          }),
          this.myEventShowFooter(),
        ]).then(() => {
          this.checkPeckageExpire()
          var fgf = false
          try {
            fgf = JSON.parse(sessionStorage.getItem('handleshowFGF'))
          } catch {
            fgf = false
          }
          if (!fgf) {
            if (sessionStorage.getItem('lastCloseFGF')) {
              var unixTimestamp = sessionStorage.getItem('lastCloseFGF')
              var stamptDate = moment.unix(unixTimestamp).format('YYYY-MM-DD')
              var toDayDate = moment().format('YYYY-MM-DD')
              if (toDayDate == stamptDate) {
                this.handleshowFGF(false)
              } else {
                this.handleshowFGF(true)
              }
            } else {
              this.handleshowFGF(true)
            }
          }
          this.handleLanguage(true)
          this.locale = Cache.get('BzbsLocale')
          this.textPoint = this.lbl.dashboard.you_have_points.replace(
            '{0}',
            '0',
          )
          this.textDetail = this.lbl.dashboard.points_description.replace(
            '{0}',
            '0',
          )
          this.textDetailStamp = this.lbl.dashboard.stmap_description.replace(
            '{0}',
            '0',
          )
        })
      })
    },
    getCardList() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsVD.getCards()
          .then(res => {
            this.handleLoading(false)
            this.cardData = res.data.data
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
    checkPeckageExpire() {
      this.handleLoading(true)
      BzbsPackage.apiCheckPackageExpire()
        .then(res => {
          this.handleLoading(false)
          if (res) {
            if (res.data) {
              if (res.data.data) {
                if (res.data.data.IsExpired) {
                  this.isPackageExpire = true
                  this.$bvModal.show('package_expire_modal')
                } else {
                  this.isPackageExpire = false
                  this.$bvModal.hide('package_expire_modal')
                }
              }
            }
          }
        })
        .catch(err => {
          this.handleLoading(false)
          console.log(err)
        })
    },
    myEventShowFooter() {
      setTimeout(() => this.checkFooter(), 300)
    },
    checkFooter() {
      if (this.windowWidth >= 600 && this.windowHeight >= 600) {
        this.isTablat = true
        this.handleFooter(false)
      } else {
        this.isTablat = false
        this.handleFooter(true)
        this.getInfoPointsExpired()
      }
    },
    changeActiveKey(e) {
      this.ActiveKey = String(e)
    },
    getConfigEcommerceBrand() {
      Config.getConfigEcommerceBrand()
        .then(res => {
          if (res.isShowEarnCode != undefined) {
            this.isShowEarnCode = res.isShowEarnCode
          } else {
            this.isShowEarnCode = true
          }
          if (res.isShowPoint != undefined) {
            this.isShowPoint = res.isShowPoint
          } else {
            this.isShowPoint = true
          }
          if (res.DefaultECode != undefined) {
            this.ActiveKey = String(res.DefaultECode)
          } else {
            this.ActiveKey = '1'
          }
        })
        .catch(() => {
          this.isShowEarnCode = true
          this.isShowPoint = true
          this.ActiveKey = '1'
        })
    },
    handleLoading(value) {
      this.$store.commit('Loading', value)
    },
    getProfileLevel() {
      var params = {
        token: Account.getCacheToken() ? Account.getCacheToken() : null,
      }
      return new Promise(resolve => {
        BzbsProfile.getProfileLevel(params)
          .then(res => {
            this.handleLoading(false)
            this.genDataLevel(res.data.data)
            resolve(res.data)
          })
          .catch(error => {
            console.log(error)
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    getProfileLevelSpending() {
      var params = {
        token: Account.getCacheToken() ? Account.getCacheToken() : null,
      }
      return new Promise(resolve => {
        BzbsProfile.getProfileLevelSpending(params)
          .then(res => {
            this.handleLoading(false)
            this.genDataLevelSpending(res.data.data)
            resolve(res.data)
          })
          .catch(error => {
            console.log(error)
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    genDataLevel(data) {
      console.log('genDataLevel : ', data)
      this.profileLevel.currentPoints = data.currentPoints
      this.profileLevel.currentLevel = data.currentLevel
      this.profileLevel.currentLevelName = data.currentLevelName
      this.profileLevel.currentLevelIcon = data.currentLevelIcon
      this.profileLevel.maxLevelPoints = data.maxLevelPoints
      this.profileLevel.nextLevelName = data.nextLevelName
      this.profileLevel.currentEarnPoints = data.currentEarnPoints
      this.profileLevel.nextLevelPoints = data.nextLevelPoints
      this.profileLevel.percentage = data.percentage
      this.profileLevel.nextLevelIcon = data.nextLevelIcon
      this.userLevel = data.currentLevel
    },
    genDataLevelSpending(data) {
      console.log('genDataLevelSpending : ', data)
      this.profileLevel.currentLevel = data.currentLevel
      this.profileLevel.currentLevelName = data.currentLevelName
      this.profileLevel.currentLevelIcon = data.currentLevelIcon
      this.profileLevel.maxLevelSpending = data.maxLevelSpending
      this.profileLevel.nextLevelName = data.nextLevelName
      this.profileLevel.nextLevelIcon = data.nextLevelIcon
      this.profileLevel.currentSpending = data.currentSpending
      this.profileLevel.nextLevelSpending = data.nextLevelSpending
      this.profileLevel.percentage = data.percentage
      this.userLevel = data.currentLevel
    },
    getUserLevelList() {
      BzbsDashboard.getUserLevelList().then(res => {
        if (!res.data.length) {
          this.userLevel = false
          this.haveUserLevel = false
        } else {
          if (res.data[0].HideLevelOnConsumerView) {
            this.isDisplayUserLevel = false
            this.userLevel = false
            this.haveUserLevel = false
          } else {
            this.haveUserLevel = res.data[0].Active
            this.currentLevel = res.data.find(item => {
              return item.UserLevel === this.userLevel
            })
            if (this.currentLevel == undefined) {
              this.currentLevel = res.data[res.data.length - 1]
            }
          }
        }
      })
    },
    getUserLevel() {
      return new Promise(resolve => {
        this.getUserLevelList()
        console.log('this.levelmode :: ', this.levelmode)
        if (this.levelmode == 'spending') {
          this.getProfileLevelSpending()
        } else {
          this.getProfileLevel()
        }
        resolve()
      })
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            if (res) {
              if (res.data) {
                this.version.last_terms = res.data.TermAndCondition.Version
                this.version.last_privacy = res.data.PrivacyPolicy.Version
                if (res.data.StoreDetail) {
                  this.levelmode = res.data.StoreDetail.levelmode
                  this.isStore = res.data.StoreDetail.StoreType
                  this.loginType = res.data.StoreDetail.LoginType
                  this.ShowValueDesignOnConsumer =
                    res.data.StoreDetail.ShowValueDesignOnConsumer
                  resolve(res.data)
                } else {
                  resolve(res.data)
                }
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
            this.getMarketingConsent()
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
    getProfile() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getProfile()
          .then(res => {
            this.handleLoading(false)
            if (res) {
              if (res.data) {
                this.textPoint = this.lbl.dashboard.you_have_points.replace(
                  '{0}',
                  res.data.updated_points.points,
                )
                this.Point = res.data.updated_points.points
                this.version.currect_terms = res.data.TermAndCondition
                this.version.currect_privacy = res.data.DataPrivacy
                resolve(res.data)
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            this.handleLoading(false)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '2',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    getPoints() {
      this.resetProfile = false
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getPoint()
          .then(res => {
            this.handleLoading(false)
            if (res) {
              if (res.data) {
                this.Barcode = res.data
                this.setTime(this.Barcode.expirein)
                resolve(res.data)
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getPoint error', error)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '3', //No Wallet Token
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    handleGetCampaignList() {
      if (this.countGetCampaign == 0) {
        this.handleLoading(true)
        this.getCampaignList()
      }
    },

    ChangeLayoutHome(res) {
      this.getConfigEcommerceBrand()
      this.getProfile()

      this.dataLayoutHome = res
      this.textWelcome = res.data.textWelcome
      this.backgroundColor = res.data.StoreDetail.ButtonColor
      this.textColor = res.data.StoreDetail.ButtonTextColor
      this.backgroundPointColor =
        res.data.StoreDetail.PointButtonBackgroundColor

      this.modalcondition.storeinfo.buttoncolor = this.backgroundColor
      this.modalcondition.storeinfo.buttontextcolor = this.textColor
      if (
        (res.data.StoreDetail.PointButtonTextColor == '#FFFFFF' ||
          res.data.StoreDetail.PointButtonTextColor == '#FFF' ||
          res.data.StoreDetail.PointButtonTextColor == 'rgb(255, 255, 255)') &&
        this.windowWidth >= 600 &&
        this.windowHeight >= 600
      ) {
        this.textPointColor = '#6ace74'
      } else {
        this.textPointColor = res.data.StoreDetail.PointButtonTextColor
      }

      this.isStore = res.data.StoreDetail.StoreType

      if (res.data.EarnDetail != null) {
        this.textDetail = this.lbl.dashboard.points_description.replace(
          '{0}',
          res.data.EarnDetail.PointRatio,
        )
      }

      this.storeinfo.image_header = res.data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = res.data.StoreDetail.LogoUrl
      this.storeinfo.businessName = res.data.StoreDetail.BusinessName
      this.levelmode = res.data.StoreDetail.levelmode

      //TODO Check terminate
      // this.isStoreTerminate = true
      this.checkPeckageExpire()
      this.updateProfile().then(res => {
        this.handleLoading(false)
        console.log('updateProfile : ', res)
        var user = Account.getCache(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        )
        Account.setCacheToken(res.data.Token)
        user.locale = res.data.Locale
        user.UserLevel = res.data.UserLevel
        Account.setCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
          user,
        )

        if (this.isStore == 'stamp') {
          this.getStamp()
        }
        this.handleGetCampaignList()

        if (this.$route.name == 'codescan') {
          if (this.isStore == 'stamp') {
            setTimeout(() => this.handleGetStamp(), 200)
          } else {
            setTimeout(() => this.handleGetPoints(), 200)
          }
        }
      })
    },
    ChangeGetPoints(event) {
      if (event == true) {
        this.showModalBarcode = true
        this.imageLogo = this.dataLayoutHome.data.StoreDetail.LogoUrl
        this.getPoints()
      }
    },
    ChangeGetStamp(event) {
      if (event == true) {
        this.showModalBarcode = true
        this.imageLogo = this.dataLayoutHome.data.StoreDetail.LogoUrl
        this.getPaycodeStamp()
      }
    },
    getInfoPointsExpired() {
      if (
        Account.getCacheCustom(
          'profileLine_' + Account.getCacheCustom('app_id'),
        )
      ) {
        if (
          Account.getCacheCustom(
            'profileLine_' + Account.getCacheCustom('app_id'),
          ).pictureUrl
        ) {
          this.profile_url = JSON.stringify(
            Account.getCacheCustom(
              'profileLine_' + Account.getCacheCustom('app_id'),
            ).pictureUrl,
          ).replace(/"/g, '')
        } else {
          this.profile_url = null
        }
      }

      this.getPointsExpired()
    },
    getPointsExpired() {
      return new Promise(resolve => {
        BzbsDashboard.getUserExpriedPoint()
          .then(res => {
            this.handleLoading(false)
            if (res) {
              console.log('getUserExpriedPoint', res)
              this.genPointsExpired(res)
              resolve(res)
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            this.handleLoading(false)
            this.isPointsExpired = true
            console.log('getUserExpriedPoint error', error)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '4',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    genPointsExpired(res) {
      if (res.data.data.length > 0) {
        this.isPointsExpired = false
        this.PointsExpired = res.data.data[0].Point
        if (Cache.get('BzbsLocale') == 'th') {
          moment.locale('th')
        } else {
          moment.locale('en')
        }

        var strDate = moment
          .unix(res.data.data[0].ExpireDate)
          .utc()
          .format('DD/MM/')
        var year = moment.unix(res.data.data[0].ExpireDate).utc().format('YYYY')
        year = this.getYearLocale(year).toString()
        year = year.substring(2, 4)
        this.DateExpired = strDate + year
      } else {
        this.isPointsExpired = true
      }
    },
    getYearLocale: function (year) {
      if (Cache.get('BzbsLocale') == 'th') {
        return parseInt(year) + 543
      }
      return year
    },
    ChangePointsExpired(event) {
      if (event == true) {
        let Expired = []
        this.getPointsExpired().then(res => {
          _.forEach(res.data.data, item => {
            if (Cache.get('BzbsLocale') == 'th') {
              moment.locale('th')
            } else {
              moment.locale('en')
            }

            var strDate = moment.unix(item.ExpireDate).utc().format('DD MMMM ')
            var year = moment.unix(item.ExpireDate).utc().format('YYYY')
            year = this.getYearLocale(year).toString()
            Expired.push({ point: item.Point, date: strDate + year })
          })

          let point_detail = ''
          if (this.dataLayoutHome.data.EarnDetail != null) {
            point_detail = this.lbl.dashboard.point_detail.replace(
              '{0}',
              this.dataLayoutHome.data.EarnDetail.PointRatio,
            )
          } else {
            point_detail = this.lbl.dashboard.point_detail.replace('{0}', '')
          }

          this.showPointsExpired = true
          this.dataPointsExpired = {
            title: this.lbl.dashboard.point_info,
            detail: point_detail,
            expired: Expired,
          }
        })
      }
    },
    handlePointsExpired() {
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_points_info',
        'click_points_info',
        'on click',
      )
      let Expired = []
      this.getPointsExpired().then(res => {
        _.forEach(res.data.data, item => {
          if (Cache.get('BzbsLocale') == 'th') {
            moment.locale('th')
          } else {
            moment.locale('en')
          }

          var strDate = moment.unix(item.ExpireDate).utc().format('DD MMMM ')
          var year = moment.unix(item.ExpireDate).utc().format('YYYY')
          year = this.getYearLocale(year).toString()
          Expired.push({ point: item.Point, date: strDate + year })
        })

        let point_detail = ''
        if (this.dataLayoutHome.data.EarnDetail != null) {
          point_detail = this.lbl.dashboard.point_detail.replace(
            '{0}',
            this.dataLayoutHome.data.EarnDetail.PointRatio,
          )
        } else {
          point_detail = this.lbl.dashboard.point_detail.replace('{0}', '')
        }

        this.showPointsExpired = true
        this.dataPointsExpired = {
          title: this.lbl.dashboard.point_info,
          detail: point_detail,
          expired: Expired,
        }
      })
    },
    updateProfile() {
      this.objProfileInfo.strLocale =
        Cache.get('BzbsLocale') == 'th' ? 1054 : 1033
      return new Promise(resolve => {
        BzbsProfile.updateProfileNew(
          Account.getCacheToken() ? Account.getCacheToken() : null,
          this.objProfileInfo,
          null,
          null,
          null,
          null,
        )
          .then(res => {
            console.log(res)
            resolve(res)
          })
          .catch(error => {
            this.handleLoading(false)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '5',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    handleGetPoints() {
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_get_points',
        'click_get_points',
        'on click',
      )
      var path = window.location.origin + '/home'
      this.checkPdpaVersion(this.version, path).then(res => {
        if (res) {
          this.showModalBarcode = true
          this.imageLogo = this.dataLayoutHome.data.StoreDetail.LogoUrl
          this.getPoints()
        }
      })
    },
    handleUsePoints(e) {
      console.log('handleUsePoints : ', e.target.value)
      window.location.href = '/campaigndetail/' + e.target.value
    },
    handleDetail(e) {
      console.log('handleDetail : ', e)
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_goto_campaigndetail',
        'click_goto_campaigndetail',
        'on click',
      )
      window.location.href = '/campaigndetail/' + e
    },
    goto(name) {
      Account.bzbsAnalyticTracking(
        'home_page',
        'value_design',
        'click_go_to_my_card',
        'on click',
      )
      this.$router.push({ name: name })
    },
    setTime(seconds) {
      clearInterval(intervalTimer)
      this.timer(seconds)
    },
    timer(seconds) {
      const now = Date.now()
      const end = now + seconds * 1000
      this.isTime = false
      this.displayTimeLeft(seconds)
      this.selectedTime = seconds
      this.countdown(end)
    },
    countdown(end) {
      intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000)
        if (secondsLeft === 0) {
          this.endTime = 0
          this.isTime = true
        }
        if (secondsLeft < 0) {
          clearInterval(intervalTimer)
          return
        }
        this.displayTimeLeft(secondsLeft)
      }, 1000)
    },
    displayTimeLeft(secondsLeft) {
      const math_minutes = Math.floor((secondsLeft % 3600) / 60)
      const minutes = ('0' + math_minutes).slice(-2)
      const math_seconds = secondsLeft % 60
      const seconds = ('0' + math_seconds).slice(-2)
      this.timeLeft = minutes + ' : ' + seconds
    },

    getMarketingConsent() {
      let token = Account.getCacheToken() ? Account.getCacheToken() : null
      this.isShowConsentMarketing = false
      return new Promise((resolve, reject) => {
        BzbsAuth.actionGetMarketing(token)
          .then(res => {
            this.originalConsent = res.data
            if (!Vue.bzbsConfig.businessRule.webFor.PH) {
              if (this.loginType.includes('Line')) {
                if (this.originalConsent.LineMarketing == 0) {
                  if (Account.getTimeStampMarKetingConsent()) {
                    this.checkDateCounting(
                      Account.getTimeStampMarKetingConsent(),
                    )
                  } else {
                    this.isShowConsentMarketing = true
                  }
                } else {
                  this.isShowConsentMarketing = false
                }
              } else {
                this.isShowConsentMarketing = false
              }
            } else {
              this.isShowConsentMarketing = false
            }
            this.setModalCondition(res.data).then(() => {})
            resolve(true)
          })
          .catch(error => {
            if (!_.isEmpty(error.response.data.error)) {
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            }
            if (
              _.isEmpty(error.response) ||
              _.isEmpty(error.response.data.error)
            ) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            reject(error)
          })
      })
    },
    checkDateCounting(timeStamp) {
      const countingDate = moment(moment.unix(timeStamp), 'DD/MM/YYYY')
        .add(
          parseInt(this.ConsentNotification),
          this.ConsentNotificationPeriod + 's',
        )
        .unix()
      var countDate = new Date(moment.unix(countingDate).format('MM/DD/YYYY'))
      var now = new Date()
      if (now >= countDate) {
        console.log('NOT before counting date :: ', countDate)
        this.isShowConsentMarketing = true
      }
    },
    setModalCondition(data) {
      return new Promise(resolve => {
        data.EmailMarketing == 0
          ? (this.modalcondition.notification.email = false)
          : (this.modalcondition.notification.email = true)

        data.SMSMarketing == 0
          ? (this.modalcondition.notification.sms = false)
          : (this.modalcondition.notification.sms = true)

        data.LineMarketing == 0
          ? (this.modalcondition.notification.line = false)
          : (this.modalcondition.notification.line = true)

        this.modalcondition.notification.line = true
        resolve()
      })
    },
    consentSettingMarketing(valueFromChild) {
      this.handleLoading(true)
      console.log('valueFromChild :: ', valueFromChild)
      this.isSettingMarketing = false
      if (valueFromChild.confirm == 'decline') {
        this.handleLoading(false)
        this.modalcondition.notification = {
          email: false,
          sms: false,
          line: false,
        }
      } else if (valueFromChild.confirm == 'agree') {
        if (this.checkDataNoti(valueFromChild.notification)) {
          this.modalcondition.notification = valueFromChild.notification
          this.callapiMarketing().then(() => {
            this.handleLoading(false)
          })
        } else {
          this.modalcondition.notification = {
            email: false,
            sms: false,
            line: false,
          }
          this.callapiMarketing().then(() => {
            this.handleLoading(false)
          })
        }
        Account.setTimeStampMarKetingConsent()
      }
    },
    checkDataNoti(notification) {
      if (
        notification.email != false ||
        notification.sms != false ||
        notification.line != false
      ) {
        return true
      } else {
        return false
      }
    },
    callapiMarketing() {
      this.handleLoading(true)

      return new Promise((resolve, reject) => {
        let email = 0
        this.modalcondition.notification.email ? (email = 1) : (email = 0)

        let sms = 0
        this.modalcondition.notification.sms ? (sms = 1) : (sms = 0)

        let line = 0
        this.modalcondition.notification.line ? (line = 1) : (line = 0)

        let param = {
          termandcondition: '',
          dataprivacy: '',
          email: email,
          sms: sms,
          line: line,
          consentAge: '',
          marketingOption: '',
        }
        let token = Account.getCacheToken() ? Account.getCacheToken() : null
        BzbsAuth.actionPostConsent(param, token)
          .then(() => {
            resolve(true)
          })
          .catch(error => {
            if (_.isEmpty(error.response)) {
              this.handleLoading(false)
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            reject(error)
          })
      })
    },
    ChangeErrorSettingMarketing(event) {
      this.isSettingMarketing = event
    },
    //stamp
    getStamp() {
      return new Promise(resolve => {
        BzbsStamp.getStamp()
          .then(res => {
            if (res) {
              if (res.data) {
                this.getStampProfile(res.data)
                this.dataStamp = res.data
                resolve(res.data)
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            console.log('getStamp error', error)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '6',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    getStampProfile(res) {
      return new Promise(resolve => {
        BzbsStamp.getStampProfile(res.stamp.stampId, res.stamp.cardId)
          .then(res => {
            if (res) {
              if (res.data) {
                this.textDetailStamp = this.lbl.dashboard.stmap_description.replace(
                  '{0}',
                  res.data.pricePerStamp,
                )
                this.DataStampProfile = res.data
                this.genDataStamp(res.data, 0)
                resolve(res.data)
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            console.log('getStampProfile error', error)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '7',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    genDataStamp(res, skip) {
      this.backgroundStamp = this.dataLayoutHome.data.StoreDetail.StampBackgroundColor

      if (res != null) {
        this.StampProfile = []
        this.totalStamp = res.maxQuantity
        if (res.maxQuantity > 0) {
          if (res.maxQuantity > 10) {
            this.isPagination = true
            for (let i = 1 + skip; i <= res.maxQuantity; i++) {
              if (res.currentQuantity >= i) {
                this.StampProfile.push({
                  no: i,
                  is_active: true,
                  imgStamp: this.dataLayoutHome.data.StoreDetail.StampUrl,
                  isGrayscale: false,
                  current: res.currentQuantity,
                })
              } else {
                this.StampProfile.push({
                  no: i,
                  is_active: false,
                  imgStamp: '',
                  isGrayscale: false,
                  current: res.currentQuantity,
                })
              }
            }

            this.StampProfile = this.StampProfile.slice(0, 10)

            if (res.campaigns.length > 0) {
              for (let i = 0; i <= res.campaigns.length; i++) {
                let qty = ''
                if (res.campaigns[i] !== undefined) {
                  qty = res.campaigns[i].qty
                }
                _.forEach(this.StampProfile, item => {
                  if (qty != null) {
                    if (item.no == qty) {
                      item.imgStamp = res.campaigns[i].img_url
                      item.is_active = true
                      if (item.current < qty) {
                        item.isGrayscale = true
                      } else {
                        item.id = res.campaigns[i].id
                      }
                    }
                  }
                })
              }
            }
          } else {
            this.isPagination = false
            for (let i = 1; i <= res.maxQuantity; i++) {
              if (res.currentQuantity >= i) {
                this.StampProfile.push({
                  no: i,
                  is_active: true,
                  imgStamp: this.dataLayoutHome.data.StoreDetail.StampUrl,
                  isGrayscale: false,
                  current: res.currentQuantity,
                })
              } else {
                this.StampProfile.push({
                  no: i,
                  is_active: false,
                  imgStamp: '',
                  isGrayscale: false,
                  current: res.currentQuantity,
                })
              }
            }

            if (res.campaigns.length > 0) {
              for (let i = 0; i <= res.campaigns.length; i++) {
                let qty = ''
                if (res.campaigns[i] !== undefined) {
                  qty = res.campaigns[i].qty
                }
                _.forEach(this.StampProfile, item => {
                  if (qty != null) {
                    if (item.no == qty) {
                      item.imgStamp = res.campaigns[i].img_url
                      item.is_active = true
                      if (item.current < qty) {
                        item.isGrayscale = true
                      } else {
                        item.id = res.campaigns[i].id
                      }
                    }
                  }
                })
              }
            }
          }
        }
      }
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        if (
          this.backgroundStamp != '#fff' ||
          this.backgroundStamp != '#ffffff'
        ) {
          return (
            <a crm_at="previous" style="color:#fff">
              {this.lbl.btn.previous}
            </a>
          )
        } else {
          return this.lbl.btn.previous
        }
      } else if (type === 'next') {
        if (
          this.backgroundStamp != '#fff' ||
          this.backgroundStamp != '#ffffff'
        ) {
          return (
            <a crm_at="next" style="color:#fff">
              {this.lbl.btn.next}
            </a>
          )
        } else {
          return this.lbl.btn.next
        }
      }
      return originalElement
    },
    onChangePage(page) {
      this.currentStamp = page
      this.genDataStamp(this.DataStampProfile, (page - 1) * 10)
    },
    handleGetStamp() {
      var path = window.location.origin + '/home'
      this.checkPdpaVersion(this.version, path).then(res => {
        if (res) {
          this.showModalBarcode = true
          this.imageLogo = this.dataLayoutHome.data.StoreDetail.LogoUrl
          this.getPaycodeStamp()
        }
      })
    },
    getPaycodeStamp() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsStamp.getPaycodeStamp(this.dataStamp.stamp.cardId)
          .then(res => {
            this.handleLoading(false)
            if (res) {
              if (res.data) {
                console.log('getPaycodeStamp', res)
                this.Barcode = res.data
                this.setTime(this.Barcode.expirein)
                resolve(res.data)
              } else {
                resolve(res)
              }
            } else {
              resolve(true)
            }
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getPaycodeStamp error', error)
            if (error) {
              if (error.response) {
                if (error.response.status != 502) {
                  this.showError = true
                  var detectdevice = this.parser.getResult().device.model
                    ? this.parser.getResult().device.model
                    : ''
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail:
                      this.lbl.error.error_contact_support +
                      '<br/>' +
                      detectdevice +
                      ' ' +
                      this.parser.getResult().os.name,
                    log: '8',
                  }
                }
              }
            }
            resolve(error)
          })
      })
    },
    onClickStamp(id) {
      if (id != undefined) {
        window.location.href = '/campaigndetail/' + id
      }
    },

    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
    ChangeExpired(event) {
      this.showPointsExpired = event
      this.dataPointsExpired = {}
    },
    closeModalBarcode() {
      this.showModalBarcode = false
    },
    BarcodeClose() {
      setTimeout(() => this.getConfigEcommerceBrand(), 500)
      this.showModalBarcode = false
      setTimeout(() => this.reloadFunc(), 1500)
    },
    reloadFunc() {
      if (this.isStore == 'stamp') {
        this.getStamp()
      } else {
        this.getProfile().then(() => {
          if (this.levelmode == 'spending') {
            this.getProfileLevelSpending()
          } else {
            this.getProfileLevel()
          }
          this.resetProfile = true
        })
      }
    },
    getCampaignList() {
      if (this.isStore != null) {
        let type = this.isStore ? this.isStore : 'point'
        let params = {
          campaign: 'campaign_' + type,
          top: 20,
          skip: this.countGetCampaign * 20,
        }
        this.countGetCampaign = this.countGetCampaign + 1
        return new Promise(resolve => {
          BzbsDashboard.getCampaign(params)
            .then(async res => {
              this.handleLoading(false)
              if (res) {
                if (res.data) {
                  if (res.data.length > 0) {
                    _.forEach(res.data, item => {
                      var Extra = null
                      if (item.Type == 36) {
                        if (item.Extra) {
                          Extra = JSON.parse(item.Extra)
                          if (Extra.packages) {
                            this.dataList.push(item)
                          }
                        }
                      } else {
                        this.dataList.push(item)
                      }
                    })
                    await this.genCampaignList(this.dataList)
                  } else {
                    this.nomore = true
                  }
                  resolve(res.data)
                } else {
                  resolve(res)
                }
              } else {
                resolve(true)
              }
            })
            .catch(error => {
              this.handleLoading(false)
              if (error) {
                if (error.response) {
                  if (error.response.status != 502) {
                    this.showError = true
                    var detectdevice = this.parser.getResult().device.model
                      ? this.parser.getResult().device.model
                      : ''
                    this.dataError = {
                      title: this.lbl.error.errortitle,
                      detail:
                        this.lbl.error.error_contact_support +
                        '<br/>' +
                        detectdevice +
                        ' ' +
                        this.parser.getResult().os.name,
                      log: '9',
                    }
                  }
                }
              }
              resolve(error)
            })
        })
      } else {
        this.getCustomerStore().then(() => {
          this.getCampaignList()
        })
      }
    },
    async genCampaignList(data) {
      this.dataList = _.reduce(
        data,
        (unique, o) => {
          if (!unique.some(obj => obj.ID === o.ID)) {
            unique.push(o)
          }
          return unique
        },
        [],
      )

      this.totalData = this.dataList.length

      this.nomore = false
    },

    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      let bottomOfWindow = Math.round(
        ((clientHeight + scrollTop) / scrollHeight) * 100,
      )
      if (bottomOfWindow >= 90 && !this.nomore) {
        this.nomore = true
        this.getCampaignList()
      }
    },
    loadmore() {
      console.log('loadmore')
      if (!this.nomore) {
        this.nomore = true
        this.getCampaignList()
      }
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      var scrollHeight = document.body.scrollHeight
      var clientHeight = document.documentElement.clientHeight

      let bottomOfWindow = Math.round(
        ((clientHeight + scrollTop) / scrollHeight) * 100,
      )
      if (bottomOfWindow >= 90 && !this.nomore) {
        this.nomore = true
        this.getCampaignList()
      }
    },
    allowConsentMarketing() {
      this.isSettingMarketing = true
      this.$bvModal.show('wrapper__notification_setting')
    },
    closeConsentMarketing() {
      this.modalcondition.notification = {
        email: this.originalConsent.EmailMarketing == 1 ? true : false,
        sms: this.originalConsent.SMSMarketing == 1 ? true : false,
        line: this.originalConsent.LineMarketing == 1 ? true : false,
      }
      Account.setTimeStampMarKetingConsent()
      this.callapiMarketing().then(() => {
        this.handleLoading(false)
      })
    },
    isTypePackage(extra) {
      try {
        if (extra) {
          var js = JSON.parse(extra)
          if (js.packages) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } catch {
        return false
      }
    },
    displayQTY(extra) {
      try {
        if (extra) {
          var js = JSON.parse(extra)
          var packages
          if (typeof js.packages !== 'string') {
            packages = js.packages
          } else {
            try {
              packages = JSON.parse(js.packages)
            } catch {
              packages = null
            }
          }

          if (packages.length && packages[0].id && packages[0].qty) {
            return packages[0].qty
          } else {
            return '0'
          }
        } else {
          return ''
        }
      } catch {
        return ''
      }
    },
    dateShortFormatUTC: function (timestamp, isdonotshowtime) {
      moment.locale(Locale.getLocale())
      var strDate = moment.unix(timestamp).utc().format('DD MMM ')
      var year = moment.unix(timestamp).utc().format('YYYY')
      var strtime = moment.unix(timestamp).utc().format('HH:mm')
      year = this.getYearByLocale(year)
      if (moment.locale(Locale.getLocale()) == 'th') {
        year = this.substring(year)
      }
      var time = ''
      if (isdonotshowtime) {
        time = strDate + year
      } else {
        time = strDate + year + ' - ' + strtime
      }

      return time
    },
    substring(value) {
      var str = value
      return str
    },
    getYearByLocale: function (year) {
      if (Locale.getLocale() == 'th') {
        return parseInt(year) + 543
      } else {
        return year
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
.wrapper-dashboard {
  font-family: 'ibm-plex-thai', sans-serif;
  .profile__image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-top: -5px;
    margin-right: 5px;
  }

  .ant-pagination-next {
    float: right;
    font-size: 12px;
    font-weight: 700;
  }

  .ant-pagination-prev {
    float: left;
    font-size: 12px;
    font-weight: 700;
  }

  .ant-pagination-item {
    display: none;
  }

  li.ant-pagination-disabled.ant-pagination-prev {
    float: left;
    font-size: 12px;
    font-weight: 700;
  }

  li.ant-pagination-disabled.ant-pagination-next {
    float: right;
    font-size: 12px;
    font-weight: 700;
  }

  .btn-use-stamp {
    min-width: 120px;
  }

  .stamp-index {
    width: 54px;
    height: 54px;
    object-fit: contain;
    border-radius: 100px;
    border: solid 3px #e5e5e5;
    background-color: #f0f0f0;
    padding-top: 12px;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #858585;
  }

  .active_stamp {
    background-size: contain;
    color: transparent !important;
    border: initial !important;
  }

  .isGrayscale {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }

  .stamp-circle {
    width: 20%;
    margin: 0px 0px 10px;
  }

  .box-stamp {
    margin: 0px 15px;
    padding: 22px 15px;
    border-radius: 15px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #eee;
    background-color: #fff;
    text-align: -webkit-center;
  }

  .use-points {
    bottom: 0px;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
  }

  .expire {
    font-size: 12px;
    color: #999999;
  }

  .list-name {
    word-break: break-word;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    text-overflow: ellipsis;
    max-height: 4.5em;
    line-height: 1.5em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    .detail {
      -webkit-line-clamp: 2;
      overflow: inherit;
      text-overflow: ellipsis;
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }
    .name-section {
      display: flex;
      gap: 4px;
      align-items: flex-start;

      .qty {
        white-space: nowrap;
        background: #191919;
        border-radius: 30px;
        padding: 2px 8px;
        color: #ffffff;
        max-width: 100px;
        min-width: fit-content;
        text-overflow: ellipsis;
        overflow: hidden;
        .prefix {
          font-size: 10px;
        }
        .number {
          font-size: 12px;
        }
      }
    }
  }

  .detail-item {
    height: 110px;
    gap: 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .wrapper-list {
    height: 140px;
    padding: 15px;
    border-radius: 15px;
    box-shadow: 0 4px 10px 0 rgb(0 0 0 / 10%);
    border: solid 1px #eee;
    background-color: #fff;
    margin-bottom: 20px;
    display: block;
    cursor: pointer;
    width: 100%;
    background-color: #ffffff;
  }
  .wrapper-list-package {
    margin-bottom: 21px;
    position: relative;
    box-shadow: unset !important;

    .wrapper-box {
      width: 100%;
      height: 140px;
      position: absolute;
      z-index: -2;
      border-radius: 15px;
      border: solid 1px #eee;
      background-color: #fff;
      top: 0;
      left: 0;
    }
    .frame1 {
      width: 97%;
      height: 30px;
      border: solid 1px #eee;
      border-radius: 15px;
      bottom: -6px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: -4;
      background-color: #ffffff;
    }
    .frame2 {
      width: 90%;
      height: 30px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #eee;
      border-radius: 15px;
      bottom: -12px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: -5;
      background-color: #ffffff;
    }
  }

  .page-point {
    font-size: 15px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #757575;
    word-break: break-word;
  }

  .lbl-point {
    font-size: 18px;
    font-weight: 900;
    color: #424242;
  }

  .img-info {
    padding-left: 5px;
    margin-top: -7px;
    width: 32px;
  }

  .page-point-detail {
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    line-height: normal;
    color: #999;
    word-break: break-word;
  }

  .m-rectangle {
    margin-top: -25px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .label-rectangle {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }

  //แนวตั้ง mobile
  @media only screen and (max-device-width: 320px) and (orientation: portrait) {
    .pt-3,
    .py-3 {
      padding-top: 0.4rem !important;
    }

    .pt-4,
    .py-4 {
      padding-top: 0.8rem !important;
    }

    .list-name {
      width: auto;
    }

    .box-stamp {
      padding: 15px 5px;
    }
  }
}

.wrapper-dashboard {
  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    .wrapper__home__page {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      margin-top: -50px;
      background-color: white;
      .title {
        padding: 10px;
        .text-title {
          font-size: 18px;
          font-weight: 500;
          margin-left: 10px;
          color: #666;
          line-height: 1.17;
        }
      }
      padding: 0px 5px;

      .wrapper_hearder {
        padding: 20px 20px 0 20px;
      }

      .wrapper_content {
        padding: 0 20px 0 20px;
      }

      .label__checkbox {
        text-indent: 15px;
        position: absolute;
        top: -5px;
      }
      .radio-label {
        margin: 0 0 0 4px;
        font-size: 16px;
        letter-spacing: normal;
        text-align: left;
        color: $color-text-dark;
        white-space: nowrap;
        @include breakpoint-max(320) {
          font-size: 11px;
        }
      }
      .p-row {
        padding: 0px 0px 20px 0px !important;
        font-size: 16px;
      }
      .input__resetpassword {
        text-indent: 10px;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        border: solid 1px $color-input;
        background-color: #fff;
      }
      .select__resetpassword {
        text-align: center;
        padding: 15px 0px 14px 0px;
        border-radius: 10px;
        border: solid 1px $color-input;
        width: 100%;
        background-color: #fff;
        @include breakpoint-max(320) {
          padding: 7px 0px 5px 0px !important;
        }
      }

      .checkbox__condition {
        width: 20px;
        height: 20px;
      }
    }

    height: 100%;
    width: 100%;
    .wrapper__home__page {
      width: 90%;
      top: 20%;
      margin-top: 20px;
      margin-bottom: 50px;
      border-radius: 10px;
      .wrapper_content {
        padding: 0 0px 0 20px;
        margin-right: -15px;
      }
    }

    .image__hearder {
      height: 100%;
      overflow: auto;
      background-repeat: round;
      background-size: cover;
    }

    .box_content {
      min-height: 100%;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      vertical-align: middle;
      display: flex;
      width: 100%;
    }

    .logo__loginpage {
      width: 110px !important;
      background-size: contain;
      border-radius: 60px;
      height: 110px;
      margin-top: -67px;
    }

    .text-title {
      padding: 0 65px;
    }

    .footer {
      padding-bottom: 0;
    }

    .ant-list-items {
      display: flex;
      flex-wrap: wrap;
    }

    .wrapper-list {
      -ms-flex: 0 0 50%;
      -webkit-box-flex: 0;
      flex: 0 0 45%;
      max-width: 45%;
      margin: 0px 30px 20px 0px;
      border-radius: 15px !important;
      z-index: 1;
    }
    .wrapper-box {
      width: 100%;
      height: 140px;
      position: absolute;
      z-index: 2;
      border-radius: 15px;
      border: solid 1px #eee;
      background-color: #fff;
      top: 0;
      left: 0;
    }
    .frame1 {
      width: 97%;
      height: 30px;
      border: solid 1px #eee;
      border-radius: 15px;
      bottom: -6px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      background-color: #ffffff;
    }
    .frame2 {
      width: 90%;
      height: 30px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #eee;
      border-radius: 15px;
      bottom: -12px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      background-color: #ffffff;
    }
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) and (orientation: landscape) {
    .wrapper__home__page {
      margin-top: 80px !important;
      margin-bottom: 100px !important;
    }
  }

  @media only screen and (min-device-width: 900px) {
    .wrapper__home__page {
      width: 75%;
    }
  }

  @media only screen and (min-device-width: 1200px) {
    .wrapper__home__page {
      width: 60%;
    }
  }

  //แนวนอน
  @media only screen and (orientation: landscape) {
    .bzb__logo {
      position: relative;
    }
  }

  //แนวนอน
  @media only screen and (min-device-width: 640px) and (max-device-width: 823px) and (orientation: landscape) {
    .box_content {
      min-height: 740px;
    }
  }
}

.modal-Barcode {
  .barcode-container {
    width: -webkit-fill-available;
  }
  .close {
    float: right;
    display: block;
    font-size: 17px;
    font-style: normal;
    line-height: 10px;
    text-align: center;
    text-transform: none;
    text-rendering: auto;
    color: #000000;
    margin-left: -30px;
    padding-right: 13px;
    padding-top: 10px;
    font-family: cursive;

    .close-icon {
      width: 20px;
      height: 20px;
    }
  }

  button.ant-modal-close {
    display: none;
  }

  .taxt-qrcode {
    margin-top: -37px;
    z-index: 999;
    color: #000000;
    font-size: initial;
    font-family: inherit;
    font-weight: 450;
    position: relative;
    text-shadow: 0 0 0px #04040400, 0 0px 2px #0000009e;
  }

  .mt-qrcode {
    margin-top: -1.3rem;
    padding-top: 2px;
  }

  .mt-barcode {
    margin-top: 3.25rem;
  }

  .code {
    height: 190px;
    font-size: 40px;
    color: #3e3e3e;
    align-items: center;
    justify-content: center;
    word-break: break-word;
  }

  .ant-tabs {
    height: 250px;
  }

  .ant-tabs-bar {
    margin: 0 0 16px;
    border-bottom: initial;
    outline: none;
  }

  .ant-tabs-nav-wrap {
    margin-bottom: 2px;
  }

  .ant-tabs-ink-bar {
    background-color: transparent;
  }

  .ant-tabs-nav-container-scrolling {
    padding: 0;
  }

  .ant-tabs-tab-arrow-show {
    display: none;
  }

  .ant-tabs-nav .ant-tabs-tab {
    height: 27px;
    width: 90px;
    padding: 2px 13px 2px 13px;
    margin: 0 10px;
    border-radius: 100px;
    border: solid 1px #033a70;
    background-color: #fff;
    color: #033a70;
    font-weight: 500;
    transition: color 0s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .ant-tabs-nav .ant-tabs-tab-active {
    color: #fff;
    border: solid 1px #033a70;
    background-color: #033a70;
  }

  .img-qrcode {
    width: 190px;
    height: 190px;
  }

  .img-barcode {
    width: 190px;
    height: 190px;
  }

  @media only screen and (max-device-width: 320px) and (orientation: portrait) {
    .ant-tabs-nav .ant-tabs-tab {
      width: auto;
      margin: 0 5px;
    }

    .ant-modal {
      top: 70px;
    }
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    .text-title {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: #424242;
      padding: 0 15%;
    }

    .ant-pagination-next {
      float: right;
      font-size: 12px;
      font-weight: 700;
    }

    .ant-pagination-prev {
      float: left;
      font-size: 12px;
      font-weight: 700;
    }

    .ant-pagination-item {
      display: none;
    }

    li.ant-pagination-disabled.ant-pagination-prev {
      float: left;
      font-size: 12px;
      font-weight: 700;
    }

    li.ant-pagination-disabled.ant-pagination-next {
      float: right;
      font-size: 12px;
      font-weight: 700;
    }

    .btn-use-stamp {
      min-width: 120px;
    }

    .stamp-index {
      width: 54px;
      height: 54px;
      object-fit: contain;
      border-radius: 100px;
      border: solid 3px #e5e5e5;
      background-color: #f0f0f0;
      padding-top: 12px;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #858585;
    }

    .active_stamp {
      background-size: contain;
      color: transparent !important;
      border: initial !important;
    }

    .isGrayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }

    .stamp-circle {
      width: 20%;
      margin: 0px 0px 10px;
    }

    .box-stamp {
      margin: 0px 15px;
      padding: 22px 15px;
      border-radius: 15px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #eee;
      background-color: #fff;
      text-align: -webkit-center;
    }

    .div-stamp {
      margin-bottom: -10px;
    }

    .my-stamp {
      font-size: 32px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #424242;
      margin-top: 5px;
    }

    .stamp-detail {
      font-size: 12px;
      text-align: center;
      color: #999;
    }

    .close {
      float: right;
      display: block;
      font-size: 17px;
      font-style: normal;
      line-height: 20px;
      text-align: center;
      text-transform: none;
      text-rendering: auto;
      color: #000000;
      margin-left: -30px;
      padding-right: 20px;
      padding-top: 10px;
      font-family: cursive;
    }
  }
}

.btn-crm-xl {
  width: 183px;
  height: 50px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}
.btn-my-card {
  height: 50px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-crm-l {
  height: 28px;
  border-radius: 100px;
  background-color: #6ace74;
  border-color: #6ace74;
}

.btn-crm-l:active,
.btn-crm-l:hover,
.btn-crm-l:focus {
  background-color: #43ca50;
  border-color: #6ace74;
}

.ant-modal-body {
  padding: 10px;
}

.ant-modal-close-x {
  display: block;
  width: 30px;
  height: 30px;
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  color: #666666;
}

.modal-img {
  text-align: center;
}

.modal-img-logo {
  width: 110px !important;
  background-size: contain;
  border-radius: 60px;
  height: 110px;
  margin-top: -67px;
}

.color-time {
  color: #ff5252;
  font-weight: 800;
}

.img-logo-footer {
  width: 100px !important;
}

.btn-use-points {
  min-width: 120px;
}

.ant-list {
  width: 100%;
}

@media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
  .btn-use-points {
    box-shadow: initial;
  }
}
.close-btn {
  background-color: transparent;
  border: none;
  position: absolute;
  right: 20px;
  top: 10px;
  .close-icon {
    width: 16px;
    height: 16px;
  }
}
</style>
